export const antiqueData = [
  {
    id: 1,
    name: "Geometric Flower Vase",
    category: "Antique",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718962798/1_1.png",
  },
  {
    id: 2,
    name: "Gold and Black Goblet",
    category: "Antique",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718962798/1_2.png",
  },
  {
    id: 3,
    name: "Gold-Top Vase",
    category: "Antique",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718962798/1_3.png",
  },
  {
    id: 4,
    name: "Gold Chalice",
    category: "Antique",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718962798/1_4.png",
  },
  {
    id: 5,
    name: "Gold Patterned Vase",
    category: "Antique",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718962798/1_5.png",
  },
  {
    id: 6,
    name: "Gold and Black Jar",
    category: "Antique",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718962798/1_6.png",
  },
  {
    id: 7,
    name: "Candle Holders Set",
    category: "Antique",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718962798/1_7.png",
  },
  {
    id: 8,
    name: "Goblets and Orbs Set",
    category: "Antique",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718962798/1_8.png",
  },
  {
    id: 9,
    name: "Conical Decorations Set",
    category: "Antique",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718962798/1_9.png",
  },
  {
    id: 10,
    name: "Decorative Jars Set",
    category: "Antique",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718962798/1_10.png",
  },
  {
    id: 11,
    name: "Gold Bowl Set",
    category: "Antique",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718962798/1_11.png",
  },
  {
    id: 12,
    name: "Gold Goblet and Bowl Set",
    category: "Antique",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718962798/1_12.png",
  },
  {
    id: 13,
    name: "Gold Cups Set",
    category: "Antique",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718962798/1_13.png",
  },
  {
    id: 14,
    name: "Gold Tea Set",
    category: "Antique",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718962798/1_14.png",
  },
  {
    id: 15,
    name: "Gold Textured Vases Set",
    category: "Antique",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718962798/1_15.png",
  },
  {
    id: 16,
    name: "Gold Bulb Vase",
    category: "Antique",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718962798/1_16.png",
  },
  {
    id: 17,
    name: "Gold Figurine",
    category: "Antique",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718962798/1_17.png",
  },
  {
    id: 18,
    name: "Gold Bowls Set",
    category: "Antique",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718962798/1_18.png",
  },
  {
    id: 19,
    name: "Gold Cups and Bowl Set",
    category: "Antique",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718962798/1_19.png",
  },
  {
    id: 20,
    name: "Rustic Vases Set",
    category: "Antique",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718962798/1_20.png",
  },
  {
    id: 21,
    name: "Rustic Cylinder Vases Set",
    category: "Antique",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718962798/1_21.png",
  },
  {
    id: 22,
    name: "Rustic Jar Set",
    category: "Antique",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718962798/1_22.png",
  },
  {
    id: 23,
    name: "Patterned Jars Set",
    category: "Antique",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718962798/1_23.png",
  },
  {
    id: 24,
    name: "Rustic Bulb Vases Set",
    category: "Antique",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718962798/1_24.png",
  },
  {
    id: 25,
    name: "Textured Vases Set",
    category: "Antique",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718962798/1_25.png",
  },
  {
    id: 26,
    name: "Blue Glass Set",
    category: "Antique",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718962798/1_26.png",
  },
  {
    id: 27,
    name: "Patterned Glass Set",
    category: "Antique",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718962798/1_27.png",
  },
  {
    id: 28,
    name: "Antique Glass Collection",
    category: "Antique",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718962798/1_28.png",
  },
  {
    id: 29,
    name: "Clear Glass Jars Set",
    category: "Antique",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718962798/1_29.png",
  },
  {
    id: 30,
    name: "Clear and Gold Jars Set",
    category: "Antique",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718962798/1_30.png",
  },
  {
    id: 31,
    name: "Shelf of Antique Items",
    category: "Antique",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718962798/1_31.png",
  },
  {
    id: 32,
    name: "Striped Flower Vases Set",
    category: "Antique",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718962798/1_32.png",
  },
  {
    id: 33,
    name: "Floral Pattern Jar",
    category: "Antique",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718962798/1_33.png",
  },
  {
    id: 34,
    name: "Colorful Mugs Set",
    category: "Antique",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718962798/1_34.png",
  },
  {
    id: 35,
    name: "Ornate Jars Set",
    category: "Antique",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718962798/1_35.png",
  },
  {
    id: 36,
    name: "Antique Goblets Set",
    category: "Antique",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718962798/1_36.png",
  },
  {
    id: 37,
    name: "Decorative Storage Jars Set",
    category: "Antique",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718962798/1_37.png",
  },
  {
    id: 38,
    name: "Intricate Jars Set",
    category: "Antique",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718962798/1_38.png",
  },
  {
    id: 39,
    name: "Geometric Pattern Jars Set",
    category: "Antique",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718962798/1_39.png",
  },
  {
    id: 40,
    name: "Tall Rustic Vases Set",
    category: "Antique",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718962798/1_40.png",
  },
];

export const cakeStandData = [
  {
    id: 1,
    name: "Glass Dome Cake Stand",
    category: "Cake Stand",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718964193/2_1.jpg",
  },
  {
    id: 2,
    name: "Classic Glass Cake Stand",
    category: "Cake Stand",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718964193/2_2.jpg",
  },
  {
    id: 3,
    name: "Multi-View Cake Stands",
    category: "Cake Stand",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718964193/2_3.jpg",
  },
  {
    id: 4,
    name: "Wooden Base Cake Stand",
    category: "Cake Stand",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718964193/2_4.jpg",
  },
  {
    id: 5,
    name: "Small Wooden Cake Stand",
    category: "Cake Stand",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718964193/2_5.jpg",
  },
  {
    id: 6,
    name: "Glass Cake Stand with Gold Base",
    category: "Cake Stand",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718964193/2_6.jpg",
  },
  {
    id: 7,
    name: "Vintage Glass Cake Stand",
    category: "Cake Stand",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718964193/2_7.jpg",
  },
  {
    id: 8,
    name: "Tinted Glass Cake Stand",
    category: "Cake Stand",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718964193/2_8.jpg",
  },
  {
    id: 9,
    name: "Simple Glass Cake Stand",
    category: "Cake Stand",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718964193/2_9.jpg",
  },
  {
    id: 10,
    name: "Antique Gold Cake Stand",
    category: "Cake Stand",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718964193/2_10.jpg",
  },
  {
    id: 11,
    name: "Rustic Gold Cake Stand",
    category: "Cake Stand",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718964193/2_11.jpg",
  },
  {
    id: 12,
    name: "Double Tiered Cake Stand",
    category: "Cake Stand",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718964193/2_12.jpg",
  },
  {
    id: 13,
    name: "Ornate Double Tier Cake Stand",
    category: "Cake Stand",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718964193/2_13.jpg",
  },
  {
    id: 14,
    name: "Elegant Double Tier Cake Stand",
    category: "Cake Stand",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718964193/2_14.jpg",
  },
  {
    id: 15,
    name: "Gold Rim Cake Stand",
    category: "Cake Stand",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718964193/2_15.jpg",
  },
  {
    id: 16,
    name: "Glass Cake Stand with Handle",
    category: "Cake Stand",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718964193/2_16.jpg",
  },
];

export const candleFactoryData = [
  {
    id: 1,
    name: "Green Leaf Candle",
    category: "Candle factory",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718967610/3_1.jpg",
  },
  {
    id: 2,
    name: "Mind Relaxing Candles",
    category: "Candle factory",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718967610/3_2.jpg",
  },
  {
    id: 3,
    name: "Rose and Lavender Candles",
    category: "Candle factory",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718967610/3_3.jpg",
  },
  {
    id: 4,
    name: "Lavender and Vanilla Candles",
    category: "Candle factory",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718967610/3_4.jpg",
  },
  {
    id: 5,
    name: "Blueberry and Fresh Linen Candles",
    category: "Candle factory",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718967610/3_5.jpg",
  },
  {
    id: 6,
    name: "Floral Scented Candles",
    category: "Candle factory",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718967610/3_6.jpg",
  },
  {
    id: 7,
    name: "Berry and Citrus Candles",
    category: "Candle factory",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718967610/3_7.jpg",
  },
];

export const candleStandData = [
  {
    id: 1,
    name: "Green Candle Holder",
    category: "Candle Stand",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718968912/4_1.jpg",
  },
  {
    id: 2,
    name: "Red Candle Holder",
    category: "Candle Stand",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718968912/4_2.jpg",
  },
  {
    id: 3,
    name: "Silver Candle Holder Set",
    category: "Candle Stand",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718968912/4_3.jpg",
  },
  {
    id: 4,
    name: "Pink Candle Holder Set",
    category: "Candle Stand",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718968912/4_4.jpg",
  },
  {
    id: 5,
    name: "Blue Candle Holder Set",
    category: "Candle Stand",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718968912/4_5.jpg",
  },
  {
    id: 6,
    name: "Green Ball Candle Holders",
    category: "Candle Stand",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718968912/4_6.jpg",
  },
  {
    id: 7,
    name: "Golden Candle Holders",
    category: "Candle Stand",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718968912/4_7.jpg",
  },
  {
    id: 8,
    name: "Red Candle Holder Set",
    category: "Candle Stand",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718968912/4_8.jpg",
  },
  {
    id: 9,
    name: "Silver and Grey Candle Holders",
    category: "Candle Stand",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718968912/4_9.jpg",
  },
  {
    id: 10,
    name: "White Candle Holders",
    category: "Candle Stand",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718968912/4_10.jpg",
  },
  {
    id: 11,
    name: "Silver Candle Holders",
    category: "Candle Stand",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718968912/4_11.jpg",
  },
  {
    id: 12,
    name: "Yellow Candle Holder Set",
    category: "Candle Stand",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718968912/4_12.jpg",
  },
  {
    id: 13,
    name: "Green Candle Holder Set",
    category: "Candle Stand",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718968912/4_13.jpg",
  },
  {
    id: 14,
    name: "Grey Candle Holder Set",
    category: "Candle Stand",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718968912/4_14.jpg",
  },
  {
    id: 15,
    name: "Silver Beaded Candle Holder",
    category: "Candle Stand",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718968912/4_15.jpg",
  },
  {
    id: 16,
    name: "Vintage Silver Candle Holder",
    category: "Candle Stand",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718968912/4_16.jpg",
  },
  {
    id: 17,
    name: "Classic Silver Candle Holder",
    category: "Candle Stand",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718968912/4_17.jpg",
  },
  {
    id: 18,
    name: "Vintage Silver Candle Holder",
    category: "Candle Stand",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718968912/4_18.jpg",
  },
  {
    id: 19,
    name: "Red Candle Holder",
    category: "Candle Stand",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718968912/4_19.jpg",
  },
  {
    id: 20,
    name: "Golden Candle Holder",
    category: "Candle Stand",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718968912/4_20.jpg",
  },
  {
    id: 21,
    name: "Classic Golden Candle Holder",
    category: "Candle Stand",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718968912/4_21.jpg",
  },
  {
    id: 22,
    name: "Tall Silver Candle Holder",
    category: "Candle Stand",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718968912/4_22.jpg",
  },
  {
    id: 23,
    name: "Wide Silver Candle Holder",
    category: "Candle Stand",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718968912/4_23.jpg",
  },
  {
    id: 24,
    name: "Ornate Silver Candle Holder",
    category: "Candle Stand",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718968912/4_24.jpg",
  },
  {
    id: 25,
    name: "Green Candle Holder",
    category: "Candle Stand",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718968912/4_25.jpg",
  },
  {
    id: 26,
    name: "Antique Silver Candle Holder",
    category: "Candle Stand",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718968912/4_26.jpg",
  },
  {
    id: 27,
    name: "Tall Silver Candle Holder",
    category: "Candle Stand",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718968912/4_27.jpg",
  },
  {
    id: 28,
    name: "Elegant Silver Candle Holder",
    category: "Candle Stand",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718968912/4_28.jpg",
  },
  {
    id: 29,
    name: "Purple Candle Holder",
    category: "Candle factory",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718968912/4_29.jpg",
  },
  {
    id: 30,
    name: "Golden Candle Holder",
    category: "Candle Stand",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718968912/4_30.jpg",
  },
  {
    id: 31,
    name: "Tall Golden Candle Holder",
    category: "Candle Stand",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718968912/4_31.jpg",
  },
  {
    id: 32,
    name: "Aqua Candle Holder",
    category: "Candle Stand",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718968912/4_32.jpg",
  },
  {
    id: 33,
    name: "Silver and Grey Candle Holder",
    category: "Candle Stand",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718968912/4_33.jpg",
  },
  {
    id: 34,
    name: "Ornate Silver Candle Holder",
    category: "Candle Stand",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718968912/4_34.jpg",
  },
  {
    id: 35,
    name: "Elegant Silver Candle Holder",
    category: "Candle Stand",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718968912/4_35.jpg",
  },
  {
    id: 36,
    name: "Golden Candle Holder",
    category: "Candle Stand",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718968912/4_36.jpg",
  },
  {
    id: 37,
    name: "Golden and Silver Candle Holders",
    category: "Candle Stand",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718968912/4_37.jpg",
  },
  {
    id: 38,
    name: "Silver Candle Holder",
    category: "Candle Stand",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718968912/4_38.jpg",
  },
  {
    id: 39,
    name: "Silver and Blue Candle Holders",
    category: "Candle Stand",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718968912/4_39.jpg",
  },
];

export const christmashangingdata = [
  {
    id: 1,
    name: "Green Pinecones",
    category: "Christmas Hanging",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718970117/5_1.jpg",
  },
  {
    id: 2,
    name: "Gold Orbs",
    category: "Christmas Hanging",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718970117/5_2.jpg",
  },
  {
    id: 3,
    name: "Pink and Gold Orbs",
    category: "Christmas Hanging",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718970117/5_3.jpg",
  },
  {
    id: 4,
    name: "Green Striped Balls",
    category: "Christmas Hanging",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718970117/5_4.jpg",
  },
  {
    id: 5,
    name: "Silver and Green Orbs",
    category: "Christmas Hanging",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718970117/5_5.jpg",
  },
  {
    id: 6,
    name: "Pink Glitter Balls",
    category: "Christmas Hanging",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718970117/5_6.jpg",
  },
  {
    id: 7,
    name: "Gold and Brown Orbs",
    category: "Christmas Hanging",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718970117/5_7.jpg",
  },
  {
    id: 8,
    name: "White and Gold Balls",
    category: "Christmas Hanging",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718970117/5_8.jpg",
  },
  {
    id: 9,
    name: "Gold Star Balls",
    category: "Christmas Hanging",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718970117/5_9.jpg",
  },
  {
    id: 10,
    name: "Gold Net Orbs",
    category: "Christmas Hanging",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718970117/5_10.jpg",
  },
  {
    id: 11,
    name: "Gold and Brown Textured Balls",
    category: "Christmas Hanging",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718970117/5_11.jpg",
  },
  {
    id: 12,
    name: "Light Blue Orbs",
    category: "Christmas Hanging",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718970117/5_12.jpg",
  },
  {
    id: 13,
    name: "Silver and Blue Orbs",
    category: "Christmas Hanging",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718970117/5_13.jpg",
  },
  {
    id: 14,
    name: "White Glitter Orbs",
    category: "Christmas Hanging",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718970117/5_14.jpg",
  },
  {
    id: 15,
    name: "Silver Figurines",
    category: "Christmas Hanging",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718970117/5_15.jpg",
  },
  {
    id: 16,
    name: "Red Glitter Balls",
    category: "Christmas Hanging",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718970117/5_16.jpg",
  },
  {
    id: 17,
    name: "Blue and Silver Balls",
    category: "Christmas Hanging",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718970117/5_17.jpg",
  },
  {
    id: 18,
    name: "Green Glitter Orbs",
    category: "Christmas Hanging",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718970117/5_18.jpg",
  },
  {
    id: 19,
    name: "Gold Mesh Orbs",
    category: "Christmas Hanging",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718970117/5_19.jpg",
  },
  {
    id: 20,
    name: "Copper Balls",
    category: "Christmas Hanging",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718970117/5_20.jpg",
  },
  {
    id: 21,
    name: "Rose Gold Orbs",
    category: "Christmas Hanging",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718970117/5_21.jpg",
  },
  {
    id: 22,
    name: "White Orbs",
    category: "Christmas Hanging",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718970117/5_22.jpg",
  },
  {
    id: 23,
    name: "Silver Orbs",
    category: "Christmas Hanging",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718970117/5_23.jpg",
  },
  {
    id: 24,
    name: "Gold Pinecone",
    category: "Christmas Hanging",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718970117/5_24.jpg",
  },
  {
    id: 25,
    name: "Green and Silver Pinecones",
    category: "Christmas Hanging",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718970117/5_25.jpg",
  },
  {
    id: 26,
    name: "Gold and Brown Textured Orbs",
    category: "Christmas Hanging",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718970117/5_26.jpg",
  },
  {
    id: 27,
    name: "Pink and Gold Orbs",
    category: "Christmas Hanging",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718970117/5_27.jpg",
  },
  {
    id: 28,
    name: "Gold Pinecones",
    category: "Christmas Hanging",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718970117/5_28.jpg",
  },
  {
    id: 29,
    name: "Green Orbs",
    category: "Christmas Hanging",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718970117/5_29.jpg",
  },
];

export const christmastreeData = [
  {
    id: 1,
    name: "White Snowflake Tree",
    category: "Christmas Tree",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718983080/6_1.png",
  },
  {
    id: 2,
    name: "White Cone Tree",
    category: "Christmas Tree",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718983080/6_2.png",
  },
  {
    id: 3,
    name: "White Textured Tree",
    category: "Christmas Tree",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718983080/6_3.png",
  },
  {
    id: 4,
    name: "Gold and Black Cone Set",
    category: "Christmas Tree",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718983080/6_4.png",
  },
  {
    id: 5,
    name: "Christmas Tree Decor Set",
    category: "Christmas Tree",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718983080/6_5.png",
  },
  {
    id: 6,
    name: "Green Snowflake Tree",
    category: "Christmas Tree",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718983080/6_6.png",
  },
  {
    id: 7,
    name: "Green Cone Tree (with lights)",
    category: "Christmas Tree",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718983080/6_7.png",
  },
  {
    id: 8,
    name: "Green Slim Cone Tree",
    category: "Christmas Tree",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718983080/6_8.png",
  },
  {
    id: 9,
    name: "Green Textured Tree (with lights)",
    category: "Christmas Tree",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718983080/6_9.png",
  },
  {
    id: 10,
    name: "Green Snowflake Tree (with lights)",
    category: "Christmas Tree",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718983080/6_10.png",
  },
  {
    id: 11,
    name: "Silver Cone Tree Set",
    category: "Christmas Tree",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718983080/6_11.png",
  },
  {
    id: 12,
    name: "Silver Textured Tree",
    category: "Christmas Tree",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718983080/6_12.png",
  },
];

export const candleHolderData = [
  {
    id: 1,
    name: "Tall Glass Candle Holder",
    category: "Candle Holder",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718983133/7_1.jpg",
  },
  {
    id: 2,
    name: "Dome Glass Candle Holder Set",
    category: "Candle Holder",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718983133/7_2.jpg",
  },
  {
    id: 3,
    name: "Rustic Glass Candle Holder",
    category: "Candle Holder",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718983133/7_3.jpg",
  },
  {
    id: 4,
    name: "Textured Glass Candle Holder",
    category: "Candle Holder",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718983133/7_4.jpg",
  },
  {
    id: 5,
    name: "Leaf Pattern Glass Candle Holder",
    category: "Candle Holder",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718983133/7_5.jpg",
  },
  {
    id: 6,
    name: "Square Base Glass Candle Holder",
    category: "Candle Holder",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718983133/7_6.jpg",
  },
];

export const jarData = [
  {
    id: 1,
    name: "Classic Glass Jar",
    category: "Jar",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718983198/8_1.jpg",
  },
  {
    id: 2,
    name: "Striped Glass Jar",
    category: "Jar",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718983198/8_2.jpg",
  },
  {
    id: 3,
    name: "Multi-Stripe Glass Jar",
    category: "Jar",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718983198/8_3.jpg",
  },
  {
    id: 4,
    name: "Round Glass Jar",
    category: "Jar",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718983198/8_4.jpg",
  },
  {
    id: 5,
    name: "Tall Glass Jar",
    category: "Jar",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718983198/8_5.jpg",
  },
  {
    id: 6,
    name: "Wide Stripe Glass Jar",
    category: "Jar",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718983198/8_6.jpg",
  },
];

export const pumpkinData = [
  {
    id: 1,
    name: "Classic Orange Pumpkin",
    category: "Pumpkin",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718983362/9_1.jpg",
  },
  {
    id: 2,
    name: "Happy Jack-o'-Lantern",
    category: "Pumpkin",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718983362/9_2.jpg",
  },
  {
    id: 3,
    name: "Spooky Carved Pumpkin",
    category: "Pumpkin",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718983362/9_3.jpg",
  },
  {
    id: 4,
    name: "Pumpkin Patch Trio",
    category: "Pumpkin",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718983362/9_4.jpg",
  },
  {
    id: 5,
    name: "Pumpkin with Witch Hat",
    category: "Pumpkin",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718983362/9_5.jpg",
  },
  {
    id: 6,
    name: "Vintage Pumpkin Decor",
    category: "Pumpkin",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718983362/9_6.jpg",
  },
  {
    id: 7,
    name: "Miniature Pumpkins",
    category: "Pumpkin",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718983362/9_7.jpg",
  },
  {
    id: 8,
    name: "Glittery Pumpkin",
    category: "Pumpkin",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718983362/9_8.jpg",
  },
  {
    id: 9,
    name: "Pumpkin String Lights",
    category: "Pumpkin",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718983362/9_9.jpg",
  },
  {
    id: 10,
    name: "Harvest Pumpkin Display",
    category: "Pumpkin",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718983362/9_10.jpg",
  },
  {
    id: 11,
    name: "Ghostly White Pumpkin",
    category: "Pumpkin",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718983362/9_11.jpg",
  },
  {
    id: 12,
    name: "Elegant Black Pumpkin",
    category: "Pumpkin",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718983362/9_12.jpg",
  },
  {
    id: 13,
    name: "Golden Pumpkin",
    category: "Pumpkin",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718983362/9_13.jpg",
  },
  {
    id: 14,
    name: "Rustic Burlap Pumpkin",
    category: "Pumpkin",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718983362/9_14.jpg",
  },
  {
    id: 15,
    name: "Luminous Pumpkin Lantern",
    category: "Pumpkin",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718983362/9_15.jpg",
  },
  {
    id: 16,
    name: "Painted Pumpkin Art",
    category: "Pumpkin",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718983362/9_16.jpg",
  },
  {
    id: 17,
    name: "Striped Pumpkin",
    category: "Pumpkin",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718983362/9_17.jpg",
  },
  {
    id: 18,
    name: "Sparkling Pumpkin",
    category: "Pumpkin",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718983362/9_18.jpg",
  },
  {
    id: 19,
    name: "Hand-Carved Pumpkin",
    category: "Pumpkin",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718983362/9_19.jpg",
  },
  {
    id: 20,
    name: "Mosaic Pumpkin",
    category: "Pumpkin",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718983362/9_20.jpg",
  },
  {
    id: 21,
    name: "Pumpkin with Scary Face",
    category: "Pumpkin",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718983362/9_21.jpg",
  },
  {
    id: 22,
    name: "Pumpkin with Bat Wings",
    category: "Pumpkin",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718983362/9_22.jpg",
  },
  {
    id: 23,
    name: "Pumpkin with LED Lights",
    category: "Pumpkin",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718983362/9_23.jpg",
  },
  {
    id: 24,
    name: "Pumpkin with Funny Face",
    category: "Pumpkin",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718983362/9_24.jpg",
  },
  {
    id: 25,
    name: "Pumpkin with Candle Inside",
    category: "Pumpkin",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718983362/9_25.jpg",
  },
  {
    id: 26,
    name: "Metallic Pumpkin",
    category: "Pumpkin",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718983362/9_26.jpg",
  },
  {
    id: 27,
    name: "Colorful Painted Pumpkin",
    category: "Pumpkin",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718983362/9_27.jpg",
  },
  {
    id: 28,
    name: "Large Pumpkin Decor",
    category: "Pumpkin",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718983362/9_28.jpg",
  },
  {
    id: 29,
    name: "Small Pumpkin Set",
    category: "Pumpkin",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718983362/9_29.jpg",
  },
  {
    id: 30,
    name: "Pumpkin with Spider Webs",
    category: "Pumpkin",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718983362/9_30.jpg",
  },
  {
    id: 31,
    name: "Pumpkin with Creepy Eyes",
    category: "Pumpkin",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718983362/9_31.jpg",
  },
  {
    id: 32,
    name: "Pumpkin with Ghost Design",
    category: "Pumpkin",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718983362/9_32.jpg",
  },
  {
    id: 33,
    name: "Pumpkin with Skull",
    category: "Pumpkin",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718983362/9_33.jpg",
  },
  {
    id: 34,
    name: "Pumpkin with Autumn Leaves",
    category: "Pumpkin",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718983362/9_34.jpg",
  },
  {
    id: 35,
    name: "Pumpkin with Witch Broom",
    category: "Pumpkin",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718983362/9_35.jpg",
  },
  {
    id: 36,
    name: "Pumpkin with Black Cat",
    category: "Pumpkin",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718983362/9_36.jpg",
  },
  {
    id: 37,
    name: "Pumpkin with Vampire Teeth",
    category: "Pumpkin",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718983362/9_37.jpg",
  },
  {
    id: 38,
    name: "Pumpkin with Eyeballs",
    category: "Pumpkin",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718983362/9_38.jpg",
  },
  {
    id: 39,
    name: "Pumpkin with Haunted House",
    category: "Pumpkin",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718983362/9_39.jpg",
  },
];

export const vasedata = [
  {
    id: 1,
    name: "Flower Vase",
    category: "Vase",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718983534/10_1.jpg",
  },
  {
    id: 2,
    name: "Colorful Bottle Vases",
    category: "Vase",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718983534/10_2.jpg",
  },
  {
    id: 3,
    name: "Tall Floral Vase",
    category: "Vase",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718983534/10_3.jpg",
  },
  {
    id: 4,
    name: "Elegant Cylinder Vases",
    category: "Vase",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718983534/10_4.jpg",
  },
  {
    id: 5,
    name: "White Tall Vases",
    category: "Vase",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718983534/10_5.jpg",
  },
  {
    id: 6,
    name: "Single Tall Vase",
    category: "Vase",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718983534/10_6.jpg",
  },
  {
    id: 7,
    name: "Blue Bottle Vases",
    category: "Vase",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718983534/10_7.jpg",
  },
  {
    id: 8,
    name: "Set of Gray Vases",
    category: "Vase",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718983534/10_8.jpg",
  },
  {
    id: 9,
    name: "Assorted Pattern Vases",
    category: "Vase",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718983534/10_9.jpg",
  },
  {
    id: 10,
    name: "Textured Vases",
    category: "Vase",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718983534/10_10.jpg",
  },
  {
    id: 11,
    name: "Diamond Pattern Vases",
    category: "Vase",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718983534/10_11.jpg",
  },
  {
    id: 12,
    name: "Square White Vase",
    category: "Vase",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718983534/10_12.jpg",
  },
  {
    id: 13,
    name: "Turquoise Vase",
    category: "Vase",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718983534/10_13.jpg",
  },
  {
    id: 14,
    name: "Minimalist Vases",
    category: "Vase",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718983534/10_14.jpg",
  },
  {
    id: 15,
    name: "Matte Gray Vases",
    category: "Vase",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718983534/10_15.jpg",
  },
  {
    id: 16,
    name: "Frosted Glass Vases",
    category: "Vase",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718983534/10_16.jpg",
  },
  {
    id: 17,
    name: "Flower Display Vases",
    category: "Vase",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718983534/10_17.jpg",
  },
  {
    id: 18,
    name: "Ribbed Vases",
    category: "Vase",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718983534/10_18.jpg",
  },
  {
    id: 19,
    name: "Short Pattern Vases",
    category: "Vase",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718983534/10_19.jpg",
  },
  {
    id: 20,
    name: "Abstract Pattern Vases",
    category: "Vase",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718983534/10_20.jpg",
  },
  {
    id: 21,
    name: "Small Glass Vase",
    category: "Vase",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718983534/10_21.jpg",
  },
  {
    id: 22,
    name: "Small Round Vase",
    category: "Vase",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718983534/10_22.jpg",
  },
  {
    id: 23,
    name: "Blue Glass Vase",
    category: "Vase",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718983534/10_23.jpg",
  },
  {
    id: 24,
    name: "Geometric Vase",
    category: "Vase",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718983534/10_24.jpg",
  },
  {
    id: 25,
    name: "Green Flower Vase",
    category: "Vase",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718983534/10_25.jpg",
  },
  {
    id: 26,
    name: "Lime Vase",
    category: "Vase",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718983534/10_26.jpg",
  },
  {
    id: 27,
    name: "Wide Ribbed Vase",
    category: "Vase",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718983534/10_27.jpg",
  },
  {
    id: 28,
    name: "Yellow Vase",
    category: "Vase",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718983534/10_28.jpg",
  },
  {
    id: 29,
    name: "Tall White Vase",
    category: "Vase",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718983534/10_29.jpg",
  },
  {
    id: 30,
    name: "Pink Slim Vases",
    category: "Vase",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718983534/10_30.jpg",
  },
  {
    id: 31,
    name: "Silver Slim Vase",
    category: "Vase",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718983534/10_31.jpg",
  },
  {
    id: 32,
    name: "White Patterned Vase",
    category: "Vase",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718983534/10_32.jpg",
  },
  {
    id: 33,
    name: "Rustic Vases",
    category: "Vase",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718983534/10_33.jpg",
  },
  {
    id: 34,
    name: "Vintage Vases",
    category: "Vase",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718983534/10_34.jpg",
  },
  {
    id: 35,
    name: "Simple Vase with Flower",
    category: "Vase",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718983534/10_35.jpg",
  },
  {
    id: 36,
    name: "Assorted Vases",
    category: "Vase",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718983534/10_36.jpg",
  },
  {
    id: 37,
    name: "Slim Neck Vases",
    category: "Vase",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718983534/10_37.jpg",
  },
  {
    id: 38,
    name: "Blue Slim Vase",
    category: "Vase",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718983534/10_38.jpg",
  },
  {
    id: 39,
    name: "Gold Cage Vase",
    category: "Vase",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718983534/10_39.jpg",
  },
  {
    id: 40,
    name: "Set of Floral Vases",
    category: "Vase",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718983534/10_40.jpg",
  },
  {
    id: 41,
    name: "Ornate Vase",
    category: "Vase",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718983534/10_41.jpg",
  },
  {
    id: 42,
    name: "Decorative Vases",
    category: "Vase",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718983534/10_42.jpg",
  },
  {
    id: 43,
    name: "Flower Vase Set",
    category: "Vase",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718983534/10_43.jpg",
  },
  {
    id: 44,
    name: "Artistic Vases",
    category: "Vase",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718983534/10_44.jpg",
  },
  {
    id: 45,
    name: "Elegant Flower Vase",
    category: "Vase",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718983534/10_45.jpg",
  },
  {
    id: 46,
    name: "Ribbed Floral Vases",
    category: "Vase",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718983534/10_46.jpg",
  },
  {
    id: 47,
    name: "Contemporary Flower Vase",
    category: "Vase",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718983534/10_47.jpg",
  },
  {
    id: 48,
    name: "Modern Flower Vase",
    category: "Vase",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718983534/10_48.jpg",
  },
  {
    id: 49,
    name: "Patterned Flower Vase",
    category: "Vase",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718983534/10_49.jpg",
  },
  {
    id: 50,
    name: "Single Flower Vase",
    category: "Vase",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718983534/10_50.jpg",
  },
  {
    id: 51,
    name: "Tall Floral Vase",
    category: "Vase",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718983534/10_51.jpg",
  },
  {
    id: 52,
    name: "Floral Cage Vases",
    category: "Vase",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718983534/10_52.jpg",
  },
  {
    id: 53,
    name: "Slim Vase with Flower",
    category: "Vase",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718983534/10_53.jpg",
  },
  {
    id: 54,
    name: "Hourglass Vase",
    category: "Vase",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718983534/10_54.jpg",
  },
  {
    id: 55,
    name: "Flower Display",
    category: "Vase",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718983534/10_55.jpg",
  },
  {
    id: 56,
    name: "Ribbed Vase with Flowers",
    category: "Vase",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718983534/10_56.jpg",
  },
  {
    id: 57,
    name: "Pink Flower Vase",
    category: "Vase",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718983534/10_57.jpg",
  },
  {
    id: 58,
    name: "Transparent Flower Vase",
    category: "Vase",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718983534/10_58.jpg",
  },
  {
    id: 59,
    name: "Vintage Flower Vase",
    category: "Vase",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718983534/10_59.jpg",
  },
  {
    id: 60,
    name: "Elegant Flower Vase",
    category: "Vase",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718983534/10_60.jpg",
  },
  {
    id: 61,
    name: "Simple Flower Vase",
    category: "Vase",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718983534/10_61.jpg",
  },
  {
    id: 62,
    name: "Dual Vase Display",
    category: "Vase",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718983534/10_62.jpg",
  },
  {
    id: 63,
    name: "Clear Vases with Flowers",
    category: "Vase",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718983534/10_63.jpg",
  },
  {
    id: 64,
    name: "Simple Glass Vases",
    category: "Vase",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718983534/10_64.jpg",
  },
  {
    id: 65,
    name: "Ornate Blue Vase",
    category: "Vase",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718983534/10_65.jpg",
  },
  {
    id: 66,
    name: "Elegant Vase",
    category: "Vase",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718983534/10_66.jpg",
  },
  {
    id: 67,
    name: "Modern Flower Vase ",
    category: "Vase",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718983534/10_67.jpg",
  },
  {
    id: 68,
    name: "Vintage Rustic Vase",
    category: "Vase",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718983534/10_68.jpg",
  },
  {
    id: 69,
    name: "Retro Vintage Vase",
    category: "Vase",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718983534/10_69.jpg",
  },
];
export const votivesData = [
  {
    id: 1,
    name: "Golden Votives Set",
    category: "votives",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718984046/11_1.jpg",
  },
  {
    id: 2,
    name: "Green Votives Pair",
    category: "votives",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718984046/11_2.jpg",
  },
  {
    id: 3,
    name: "Pink Floral Votives",
    category: "votives",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718984046/11_3.jpg",
  },
  {
    id: 4,
    name: "Blue Patterned Votives",
    category: "votives",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718984046/11_4.jpg",
  },
  {
    id: 5,
    name: "Green Leaf Votives",
    category: "votives",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718984046/11_5.jpg",
  },
  {
    id: 6,
    name: "White Floral Votives",
    category: "votives",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718984046/11_6.jpg",
  },
  {
    id: 7,
    name: "Gold Tinted Votives",
    category: "votives",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718984046/11_7.jpg",
  },
  {
    id: 8,
    name: "Blue Floral Votives",
    category: "votives",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718984046/11_8.jpg",
  },
  {
    id: 9,
    name: "Red Votives Set",
    category: "votives",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718984046/11_9.jpg",
  },
  {
    id: 10,
    name: "Green Floral Votives Pair",
    category: "votives",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718984046/11_10.jpg",
  },
  {
    id: 11,
    name: "Pink Patterned Votives",
    category: "votives",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718984046/11_11.jpg",
  },
  {
    id: 12,
    name: "Green Textured Votives",
    category: "votives",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718984046/11_12.jpg",
  },
  {
    id: 13,
    name: "Silver Tinted Votives",
    category: "votives",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718984046/11_13.jpg",
  },
  {
    id: 14,
    name: "Gold and Silver Votives",
    category: "votives",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718984046/11_14.jpg",
  },
  {
    id: 15,
    name: "Green Tinted Votives",
    category: "votives",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718984046/11_15.jpg",
  },
  {
    id: 16,
    name: "Green Patterned Votives",
    category: "votives",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718984046/11_16.jpg",
  },
  {
    id: 17,
    name: "Blue Tinted Votives",
    category: "votives",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718984046/11_17.jpg",
  },
  {
    id: 18,
    name: "Pink Gold Votives",
    category: "votives",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718984046/11_18.jpg",
  },
  {
    id: 19,
    name: "Pink Glass Votives",
    category: "votives",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718984046/11_19.jpg",
  },
  {
    id: 20,
    name: "Golden Pink Votives",
    category: "votives",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718984046/11_20.jpg",
  },
  {
    id: 21,
    name: "Purple Votives Set",
    category: "votives",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718984046/11_21.jpg",
  },
  {
    id: 22,
    name: "Golden Diamond Votives Set",
    category: "votives",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718984046/11_22.jpg",
  },
  {
    id: 23,
    name: "Yellow Crystal Votive",
    category: "votives",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718984046/11_23.jpg",
  },
  {
    id: 24,
    name: "Amber Votives Set",
    category: "votives",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718984046/11_24.jpg",
  },
  {
    id: 25,
    name: "White Acorn Votive",
    category: "votives",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718984046/11_25.jpg",
  },
  {
    id: 26,
    name: "Gray Bent Votive",
    category: "votives",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718984046/11_26.jpg",
  },
  {
    id: 27,
    name: "Silver Blue Votive",
    category: "votives",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718984046/11_27.jpg",
  },
  {
    id: 28,
    name: "Blue Silver Votive",
    category: "votives",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718984046/11_28.jpg",
  },
  {
    id: 29,
    name: "Blue Top Votives Set",
    category: "votives",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718984046/11_29.jpg",
  },
  {
    id: 30,
    name: "Silver Patterned Votives Set",
    category: "votives",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718984046/11_30.jpg",
  },
  {
    id: 31,
    name: "Gray Textured Votive",
    category: "votives",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718984046/11_31.jpg",
  },
  {
    id: 32,
    name: "Silver Diamond Votive",
    category: "votives",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718984046/11_32.jpg",
  },
  {
    id: 33,
    name: "Silver Brushed Votive",
    category: "votives",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718984046/11_33.jpg",
  },
  {
    id: 34,
    name: "Silver Checkered Votive",
    category: "votives",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718984046/11_34.jpg",
  },
  {
    id: 35,
    name: "Golden Diamond Votives Pair",
    category: "votives",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718984046/11_35.jpg",
  },
  {
    id: 36,
    name: "Golden Textured Votive",
    category: "votives",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718984046/11_36.jpg",
  },
  {
    id: 37,
    name: "Golden Brushed Votive",
    category: "votives",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718984046/11_37.jpg",
  },
  {
    id: 38,
    name: "Red Ombre Votives Set",
    category: "votives",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718984046/11_38.jpg",
  },
  {
    id: 39,
    name: "Orange Votive",
    category: "votives",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718984046/11_39.jpg",
  },
  {
    id: 40,
    name: "Red Ombre Votive",
    category: "votives",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718984046/11_40.jpg",
  },
  {
    id: 41,
    name: "Orange Brushed Votive",
    category: "votives",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718984046/11_41.jpg",
  },
  {
    id: 42,
    name: "Silver Ribbed Votives Pair",
    category: "votives",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718984046/11_42.jpg",
  },
  {
    id: 43,
    name: "Textured Silver Votive",
    category: "votives",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718984046/11_43.jpg",
  },
  {
    id: 44,
    name: "Ornate Silver Votive",
    category: "votives",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718984046/11_44.jpg",
  },
  {
    id: 45,
    name: "Set of Three Red and Blue Votives",
    category: "votives",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718984046/11_45.jpg",
  },
  {
    id: 46,
    name: "Single Red Votive",
    category: "votives",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718984046/11_46.jpg",
  },
  {
    id: 47,
    name: "Blue and Silver Votive",
    category: "votives",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718984046/11_47.jpg",
  },
  {
    id: 48,
    name: "Set of Blue and Silver Votives",
    category: "votives",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718984046/11_48.jpg",
  },
  {
    id: 49,
    name: "Set of Three Blue Votives",
    category: "votives",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718984046/11_49.jpg",
  },
  {
    id: 50,
    name: "Tall Blue Votive",
    category: "votives",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718984046/11_50.jpg",
  },
  {
    id: 51,
    name: "Silver Trim Blue Votive",
    category: "votives",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718984046/11_51.jpg",
  },
  {
    id: 52,
    name: "Small Blue Votive",
    category: "votives",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718984046/11_52.jpg",
  },
  {
    id: 53,
    name: "Decorative Blue Votive",
    category: "votives",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718984046/11_53.jpg",
  },
  {
    id: 54,
    name: "Small Blue and Silver Votive",
    category: "votives",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718984046/11_54.jpg",
  },
  {
    id: 55,
    name: "Set of Red and Green Votives",
    category: "votives",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718984046/11_55.jpg",
  },
  {
    id: 56,
    name: "Large Silver Votive",
    category: "votives",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718984046/11_56.jpg",
  },
  {
    id: 57,
    name: "Small Silver Votive",
    category: "votives",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718984046/11_57.jpg",
  },
  {
    id: 58,
    name: "Decorative Silver Votive",
    category: "votives",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718984046/11_58.jpg",
  },
  {
    id: 59,
    name: "Textured Small Votive",
    category: "votives",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718984046/11_59.jpg",
  },
  {
    id: 60,
    name: "Set of Two Grey Votives",
    category: "votives",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718984046/11_60.jpg",
  },
  {
    id: 61,
    name: "Set of Two White Votives",
    category: "votives",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718984046/11_61.jpg",
  },
  {
    id: 62,
    name: "Tall Grey Votive",
    category: "votives",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718984046/11_62.jpg",
  },
  {
    id: 63,
    name: "Decorative White Votive",
    category: "votives",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718984046/11_63.jpg",
  },
  {
    id: 64,
    name: "Large Gold Textured Votive",
    category: "votives",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718984046/11_64.jpg",
  },
  {
    id: 65,
    name: "Medium Gold Textured Votive",
    category: "votives",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718984046/11_65.jpg",
  },
  {
    id: 66,
    name: "Small Gold Textured Votive",
    category: "votives",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718984046/11_66.jpg",
  },
  {
    id: 67,
    name: "Gold Honeycomb Votive",
    category: "votives",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718984046/11_67.jpg",
  },
  {
    id: 68,
    name: "Gold Patterned Votive",
    category: "votives",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718984046/11_68.jpg",
  },
  {
    id: 69,
    name: "Set of Two Gold Votives",
    category: "votives",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718984046/11_69.jpg",
  },
  {
    id: 70,
    name: "Set of Two Textured Votives",
    category: "votives",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718984046/11_70.jpg",
  },
  {
    id: 71,
    name: "Round Gold Votive",
    category: "votives",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718984046/11_71.jpg",
  },
  {
    id: 72,
    name: "Set of Two Textured Votives",
    category: "votives",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718984046/11_72.jpg",
  },
  {
    id: 73,
    name: "Textured White Votive",
    category: "votives",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718984046/11_73.jpg",
  },
  {
    id: 74,
    name: "Set of Two Pink and Blue Votives",
    category: "votives",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718984046/11_74.jpg",
  },
  {
    id: 75,
    name: "Single Pink Votive",
    category: "votives",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718984046/11_75.jpg",
  },
  {
    id: 76,
    name: "Blue Patterned Votive",
    category: "votives",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718984046/11_76.jpg",
  },
  {
    id: 77,
    name: "Set of Two Owl Votives",
    category: "votives",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718984046/11_77.jpg",
  },
  {
    id: 78,
    name: "Single Blue Owl Votive",
    category: "votives",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718984046/11_78.jpg",
  },
  {
    id: 79,
    name: "Single Green Owl Votive",
    category: "votives",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718984046/11_79.jpg",
  },
  {
    id: 80,
    name: "Set of Green Textured Votives",
    category: "votives",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718984046/11_80.jpg",
  },
  {
    id: 81,
    name: "Tall Green Votive",
    category: "votives",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718984046/11_81.jpg",
  },
  {
    id: 82,
    name: "Small Green Votive",
    category: "votives",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718984046/11_82.jpg",
  },
  {
    id: 83,
    name: "Green Textured Votive",
    category: "votives",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718984046/11_83.jpg",
  },
  {
    id: 84,
    name: "Large Green Votive",
    category: "votives",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718984046/11_84.jpg",
  },
  {
    id: 85,
    name: "Small Green Votive",
    category: "votives",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718984046/11_85.jpg",
  },
  {
    id: 86,
    name: "Medium Green Votive Set",
    category: "votives",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718984046/11_86.jpg",
  },
  {
    id: 87,
    name: "Medium Green Votive",
    category: "votives",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718984046/11_87.jpg",
  },
  {
    id: 88,
    name: "Small Green Votive",
    category: "votives",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718984046/11_88.jpg",
  },
  {
    id: 89,
    name: "Green Striped Votive Set",
    category: "votives",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718984046/11_89.jpg",
  },
  {
    id: 90,
    name: "Green Striped Votive",
    category: "votives",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718984046/11_90.jpg",
  },
  {
    id: 91,
    name: "Small Green Striped Votive",
    category: "votives",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718984046/11_91.jpg",
  },
  {
    id: 92,
    name: "Green Textured Votive",
    category: "votives",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718984046/11_92.jpg",
  },
  {
    id: 93,
    name: "Tall Green Votive",
    category: "votives",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718984046/11_93.jpg",
  },
  {
    id: 94,
    name: "Green Diamond Votive",
    category: "votives",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718984046/11_94.jpg",
  },
  {
    id: 95,
    name: "Gray Votive Set",
    category: "votives",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718984046/11_95.jpg",
  },
  {
    id: 96,
    name: "Large Gray Votive",
    category: "votives",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718984046/11_96.jpg",
  },
  {
    id: 97,
    name: "Small Gray Votive",
    category: "votives",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718984046/11_97.jpg",
  },
  {
    id: 98,
    name: "Gray Textured Votive",
    category: "votives",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718984046/11_98.jpg",
  },
  {
    id: 99,
    name: "Gray Votive Set",
    category: "votives",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718984046/11_99.jpg",
  },
  {
    id: 100,
    name: "Large Textured Votive",
    category: "votives",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718984046/11_100.jpg",
  },
  {
    id: 101,
    name: "Medium Gray Votive",
    category: "votives",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718984046/11_101.jpg",
  },
  {
    id: 102,
    name: "Small Gray Textured Votive",
    category: "votives",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718984046/11_102.jpg",
  },
  {
    id: 103,
    name: "Tall Gray Votive Set",
    category: "votives",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718984046/11_103.jpg",
  },
  {
    id: 104,
    name: "Tall Gray Textured Votive",
    category: "votives",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718984046/11_104.jpg",
  },
  {
    id: 105,
    name: "Gray Votive",
    category: "votives",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718984046/11_105.jpg",
  },
  {
    id: 106,
    name: "Tall Gray Textured Votive",
    category: "votives",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718984046/11_106.jpg",
  },
  {
    id: 107,
    name: "Gray Votive Set",
    category: "votives",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718984046/11_107.jpg",
  },
  {
    id: 108,
    name: "Large Gray Votive",
    category: "votives",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718984046/11_108.jpg",
  },
  {
    id: 109,
    name: "Medium Gray Votive",
    category: "votives",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718984046/11_109.jpg",
  },
  {
    id: 110,
    name: "Small Gray Votive",
    category: "votives",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718984046/11_110.jpg",
  },
  {
    id: 111,
    name: "Turquoise Votive Set",
    category: "votives",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718984046/11_111.jpg",
  },
  {
    id: 112,
    name: "Tall Turquoise Votive",
    category: "votives",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718984046/11_112.jpg",
  },
  {
    id: 113,
    name: "Medium Turquoise Votive",
    category: "votives",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718984046/11_113.jpg",
  },
  {
    id: 114,
    name: "Blue Votive Set",
    category: "votives",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718984046/11_114.jpg",
  },
  {
    id: 115,
    name: "Tall Blue Votive",
    category: "votives",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718984046/11_115.jpg",
  },
  {
    id: 116,
    name: "Medium Blue Votive",
    category: "votives",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718984046/11_116.jpg",
  },
  {
    id: 117,
    name: "Blue Textured Votive",
    category: "votives",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718984046/11_117.jpg",
  },
  {
    id: 118,
    name: "Small Blue Votive",
    category: "votives",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718984046/11_118.jpg",
  },
  {
    id: 119,
    name: "Green Votive Set",
    category: "votives",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718984046/11_119.jpg",
  },
  {
    id: 120,
    name: "Tall Green Votive",
    category: "votives",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718984046/11_120.jpg",
  },
  {
    id: 121,
    name: "Medium Green Votive",
    category: "votives",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718984046/11_121.jpg",
  },
  {
    id: 122,
    name: "Beige Votive Set",
    category: "votives",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718984046/11_122.jpg",
  },
  {
    id: 123,
    name: "Tall Beige Votive",
    category: "votives",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718984046/11_123.jpg",
  },
  {
    id: 124,
    name: "Medium Beige Votive",
    category: "votives",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718984046/11_124.jpg",
  },
  {
    id: 125,
    name: "Beige Textured Votive",
    category: "votives",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718984046/11_125.jpg",
  },
  {
    id: 126,
    name: "Small Beige Votive",
    category: "votives",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718984046/11_126.jpg",
  },
  {
    id: 127,
    name: "Black Votive Set",
    category: "votives",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718984046/11_127.jpg",
  },
  {
    id: 128,
    name: "Tall Black Votive",
    category: "votives",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718984046/11_128.jpg",
  },
  {
    id: 129,
    name: "Medium Black Votive",
    category: "votives",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718984046/11_129.jpg",
  },
  {
    id: 130,
    name: "Multicolor Votive",
    category: "votives",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718984046/11_130.jpg",
  },
  {
    id: 131,
    name: "Orange Votive Set",
    category: "votives",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718984046/11_131.jpg",
  },
  {
    id: 132,
    name: "Tall Orange Votive",
    category: "votives",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718984046/11_132.jpg",
  },
  {
    id: 133,
    name: "Medium Orange Votive",
    category: "votives",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718984046/11_133.jpg",
  },
  {
    id: 134,
    name: "Gold and White Votive Set",
    category: "votives",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718984046/11_134.jpg",
  },
  {
    id: 135,
    name: "Tall Gold and White Votive",
    category: "votives",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718984046/11_135.jpg",
  },
  {
    id: 136,
    name: "Medium Gold and White Votive",
    category: "votives",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718984046/11_136.jpg",
  },
  {
    id: 137,
    name: "Small Gold and White Votive",
    category: "votives",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718984046/11_137.jpg",
  },
  {
    id: 138,
    name: "Gold and White Floral Votive",
    category: "votives",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718984046/11_138.jpg",
  },
  {
    id: 139,
    name: "Gold and Clear Swirl Votive",
    category: "votives",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718984046/11_139.jpg",
  },
  {
    id: 140,
    name: "Gold Ombre Votive Set",
    category: "votives",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718984046/11_140.jpg",
  },
  {
    id: 141,
    name: "Gold Ombre Votive",
    category: "votives",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718984046/11_141.jpg",
  },
  {
    id: 142,
    name: "Clear and Gold Diamond Votive",
    category: "votives",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718984046/11_142.jpg",
  },
  {
    id: 143,
    name: "Silver Etched Votive Set",
    category: "votives",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718984046/11_143.jpg",
  },
  {
    id: 144,
    name: "Silver Etched Floral Votive",
    category: "votives",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718984046/11_144.jpg",
  },
  {
    id: 145,
    name: "Silver Starburst Votive",
    category: "votives",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718984046/11_145.jpg",
  },
  {
    id: 146,
    name: "Silver and Clear Etched Votive",
    category: "votives",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718984046/11_146.jpg",
  },
  {
    id: 147,
    name: "Crystal Compote Votive",
    category: "votives",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718984046/11_147.jpg",
  },
  {
    id: 148,
    name: "Crystal Pedestal Votive",
    category: "votives",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718984046/11_148.jpg",
  },
  {
    id: 149,
    name: "Silver Striped Votive",
    category: "votives",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718984046/11_149.jpg",
  },
  {
    id: 150,
    name: "Silver Ribbed Votive",
    category: "votives",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718984046/11_150.jpg",
  },
  {
    id: 151,
    name: "Diamond Pattern Votive",
    category: "votives",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718984046/11_151.jpg",
  },
  {
    id: 152,
    name: "Clear Plaid Votive",
    category: "votives",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718984046/11_152.jpg",
  },
  {
    id: 153,
    name: "Scalloped Edge Votive",
    category: "votives",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718984046/11_153.jpg",
  },
  {
    id: 154,
    name: "Silver and Black Striped Votive",
    category: "votives",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718984046/11_154.jpg",
  },
  {
    id: 155,
    name: "Silver Owl Votive",
    category: "votives",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718984046/11_155.jpg",
  },
  {
    id: 156,
    name: "Silver Ribbed Votive",
    category: "votives",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718984046/11_156.jpg",
  },
  {
    id: 157,
    name: "Small Silver Votive",
    category: "votives",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718984046/11_157.jpg",
  },
  {
    id: 158,
    name: "Round Silver Votive",
    category: "votives",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718984046/11_158.jpg",
  },
  {
    id: 159,
    name: "Clear Ribbed Votive",
    category: "votives",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718984046/11_159.jpg",
  },
  {
    id: 160,
    name: "Set of Green Speckled Votives",
    category: "votives",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718984046/11_160.jpg",
  },
  {
    id: 161,
    name: "Green Speckled Votive",
    category: "votives",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718984046/11_161.jpg",
  },
  {
    id: 162,
    name: "Green Votive",
    category: "votives",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718984046/11_162.jpg",
  },
  {
    id: 163,
    name: "Round Green Votive",
    category: "votives",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718984046/11_163.jpg",
  },
  {
    id: 164,
    name: "Green Moss Votive",
    category: "votives",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718984046/11_164.jpg",
  },
  {
    id: 165,
    name: "Small Green Moss Votive",
    category: "votives",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718984046/11_165.jpg",
  },
  {
    id: 166,
    name: "Pink Patterned Votive",
    category: "votives",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718984046/11_166.jpg",
  },
  {
    id: 167,
    name: "Gold Heart Votive",
    category: "votives",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718984046/11_167.jpg",
  },
  {
    id: 168,
    name: "Rainbow Votive",
    category: "votives",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718984046/11_168.jpg",
  },
  {
    id: 169,
    name: "Gold Diamond Votive",
    category: "votives",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718984046/11_169.jpg",
  },
  {
    id: 170,
    name: "Gold Art Deco Votive",
    category: "votives",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718984046/11_170.jpg",
  },
  {
    id: 171,
    name: "Set of Gold Speckled Votives",
    category: "votives",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718984046/11_171.jpg",
  },
  {
    id: 172,
    name: "Gold and Grey Ombre Votives",
    category: "votives",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718984046/11_172.jpg",
  },
  {
    id: 173,
    name: "Set of Two Gold and Grey Votives",
    category: "votives",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718984046/11_173.jpg",
  },
  {
    id: 174,
    name: "Blue and Green Mosaic Votive",
    category: "votives",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718984046/11_174.jpg",
  },
  {
    id: 175,
    name: "Blue Mosaic Votive",
    category: "votives",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718984046/11_175.jpg",
  },
  {
    id: 176,
    name: "Green Mosaic Votive",
    category: "votives",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718984046/11_176.jpg",
  },
  {
    id: 177,
    name: "Red Mosaic Votive",
    category: "votives",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718984046/11_177.jpg",
  },
  {
    id: 178,
    name: "Gold and Red Mosaic Votive",
    category: "votives",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718984046/11_178.jpg",
  },
  {
    id: 179,
    name: "Multicolor Mosaic Votive",
    category: "votives",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718984046/11_179.jpg",
  },
  {
    id: 180,
    name: "Red and White Checker Votive",
    category: "votives",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718984046/11_180.jpg",
  },
  {
    id: 181,
    name: "Yellow Honeycomb Votive",
    category: "votives",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718984046/11_181.jpg",
  },
  {
    id: 182,
    name: "Set of Three Yellow Honeycomb Votives",
    category: "votives",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718984046/11_182.jpg",
  },
  {
    id: 183,
    name: "Set of Three Silver Votives",
    category: "votives",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718984046/11_183.jpg",
  },
  {
    id: 184,
    name: "Set of Three Silver Mosaic Votives",
    category: "votives",
    imageUrl:
      "https://res.cloudinary.com/dndg4fwia/image/upload/v1718984046/11_184.jpg",
  },
];
